// @flow
import React from 'react';
import ContextMenuItem from '../util/ContextMenuItem';
import IconLabel from '../util/IconLabel';
import type { IntlShape } from 'react-intl';
import { injectIntl } from 'react-intl';
import { commonMessages } from '../messages/Common';

type OwnProps = {
  onClick: Function,
  intl: IntlShape,
  disabled?: boolean,
};

const AddToPlaylistContextMenuItem = ({ onClick, intl, disabled }: OwnProps) => (
  <ContextMenuItem
    onClick={onClick}
    disabled={disabled}
    data-test="context-menu-item.add-to-playlist"
  >
    <IconLabel
      name="add-to-playlist"
      size="default"
      labelVisible
      label={intl.formatMessage(commonMessages.addToPlaylist)}
    />
  </ContextMenuItem>
);

export default injectIntl(AddToPlaylistContextMenuItem);
